import React, { useContext, useEffect, useState, useRef } from 'react';
//import { Modal, Button, Form, ListGroup, InputGroup, Col, Row, FormControl, Dropdown, FloatingLabel } from 'react-bootstrap';
import { Modal, Button, Form, Col, Row, FloatingLabel, Dropdown, ButtonGroup } from 'react-bootstrap';
import { ParentContext, CompanyContext, ActivityContext, EmployeeContext } from '../../layouts/Dashboard/LayoutDashboard';
import Select, { createFilter } from 'react-select';
import CustomOption from '../../utils/Elements/CustomOption';
import AsyncSelect from 'react-select/async';
import { toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../Pages.css';
//see this for date formats: https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
//see this for date picker: https://reactdatepicker.com/


export const ActivityForm = ({ showModal, closeModal, activityInfo, setFollowUp }) => {
  const api = process.env.REACT_APP_API_ENDPOINT;
  const activityEndpoint = `${api}/v1/activity`;
  const parentsSearch = `${api}/v1/parents/search`;
  const companySearch = `${api}/v1/companies/search`;
  const individualsSearch = `${api}/v1/individuals/search`;
  const activityTypesEndpoint = `${api}/v1/activity/types`;
  //const activityReasonsEndpoint = `${api}/v1/activity/reasons`;

  const submitRef = useRef(null);

  const { setActivityCount } = useContext(ActivityContext);
  const { selectedParentID, allParents } = useContext(ParentContext);
  const { selectedCompanyID, selectedCompanyParentID, allCompanies } = useContext(CompanyContext);
  const { allEmployees } = useContext(EmployeeContext);

  const [activitiyTypes, setActivitiyTypes] = useState([]);
  //const [activitiyReasons, setActivitiyReasons] = useState([]);

  const [activityRecurrences] = useState([
    { value: 0, label: 'Once' },
    { value: 1, label: 'Daily' },
    { value: 2, label: 'Weekly' },
    { value: 3, label: 'Monthly' },
    { value: 4, label: 'Annually' },
  ]);

  const [identity, setIdentity] = useState({});
  const [validated, setValidated] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [followupMode, setFollowupMode] = useState(false);
  const [followupSelected, setFollowUpSelected] = useState(false);
  const [checkNotes, setCheckNotes] = useState(false); //used to alert user when doning an activity to add notes
  const [checkType, setCheckType] = useState(false); //used to alert user when doning an activity to change activity type
  const [ initialActivityNotes, setInitialActivityNotes ] = useState("");

  var saveMode = 0; //0=save, 1=save and mark as done, 2=save, mark as done, create followup
  
  const defaultActivityType = activitiyTypes.find(option => option.value === 5);

  const [profile, setProfile] = useState({
    id: 0,
    parent: null,
    company: null,
    individual: null,
    //activityFor: (allEmployees.find(x => x.data === identity.sub.toUpperCase())).value,
    activityFor: null,
    //activityFor: { value: -2, label: "Value A" },
    activityType: defaultActivityType,
    activityDate: null,
    //activityRecurrence: null,
    //activityEnd: null,
    //activityStatus: null,
    activityNotes: "",
    //followupDate: null,
    followupRecurrence: null,
    followupEndDate: null,
    followupRepeatForever: true,
  });

  const clearProfile = () => {

    setProfile((prevProfile) => ({
      ...prevProfile,
      id: 0,
      parent: null,
      company: null,
      individual: null,
      //activityFor: (allEmployees.find(x => x.data === identity.sub.toUpperCase())).value,
      activityFor: null,
      //activityFor: { value: -3, label: "Value B" },
      activityType: null,
      activityDate: null,
      //activityRecurrence: null,
      //activityEnd: null,
      //activityStatus: null,
      activityNotes: "",
      //followupDate: null,
      followupRecurrence: null,
      followupEndDate: null,
      followupRepeatForever: true,
    }));

  };

  const getStoredToken = () => {
    return localStorage.getItem('token');
  };

  const storedToken = getStoredToken();

  //const parseDateString = (dateString) => {
  //  if (!dateString) return null;
  //  const [month, day, year] = dateString.split('/');
  //  return new Date(`${year}/${month}/${day}`);
  //};

  //const handleActivityEndDateChange = (date) => {
  //};


  const handleProfileChange = (event) => {
    const { name, value } = event.target;
    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: value,
    }));
  };

  const handleParentChange = (value) => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      "parent": value,
      "company": null,
      "individual": null,
    }));
  };

  const handleCompanyChange = (value) => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      "company": value,
      "individual": null,
    }));
  };

  const handleIndividualChange = (value) => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      "individual": value,
    }));
  };

  const handleActivityTypeChange = (activityTypeObj) => {
    activityTypeObj.value === 5? setFollowUpSelected(true): setFollowUpSelected(false);
    console.log(activityTypeObj)
    setProfile((prevProfile) => ({
      ...prevProfile,
      "activityType": activityTypeObj,
    }));
  };

  const handleActivityForChange = (value) => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      "activityFor": value,
    }));
  };

  //const handleActivityStatusChange = (value) => {
  //  setProfile((prevProfile) => ({
  //    ...prevProfile,
  //    "activityStatus": value,
  //  }));
  //};

  const handleFollowupRecurrenceChange = (value) => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      "followupRecurrence": value,
    }));
  };

  const handleStartDateChange = (date) => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      "activityDate": date,
    }));
  };

  //const handleFollowupDateChange = (date) => {
  //  setProfile((prevProfile) => ({
  //    ...prevProfile,
  //    "followupDate": date,
  //  }));
  //};


  const handleRepeatForeverChange = (event) => {
    const { name, checked } = event.target;
    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: checked,
    }));

  };

  const handleFollowupEndDateChange = (date) => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      "followupEndDate": date,
    }));
  };

  const showFailedMsg = () => {
    toast.error("Failed to update activity", {
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 5000,
      paueOnHover: true,
      theme: 'colored'
    });
  };

  const submitActivity = async () => {

    const payload = {
      saveMode: saveMode,
      EmployeeUID: identity.sub,
      SelectedParentID: selectedParentID,
      SelectedCompanyID: selectedCompanyID,
      ID: editMode ? profile.id : 0,
      CompanyID: profile.company.value,
      IndividualID: profile.individual.value,
      ActivityForID: profile.activityFor.value,
      TypeID: profile.activityType.value,
      StartDate: profile.activityDate,
      Comments: profile.activityNotes,
      FollowUpRecurrenceType: profile.followupRecurrence.value,
      FollowUpEndDate: profile.followupRepeatForever ? null : profile.followupEndDate,
    }


    try {

      const response = await fetch(activityEndpoint, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${storedToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      if (response.ok) {
        const data = await response.json();
        console.log("data here:",data)
        if (data.Success) {

          setActivityCount(data.UnfilteredCount);

          toast.success(editMode ? "Activity Updated!" : followupMode ? "Follow-Up Added!" : "Activity Added!", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
            paueOnHover: true,
            theme: 'colored'
          });
          if (data.activityDoneResponse.followupActivity) {
            setFollowUp(data.activityDoneResponse.followupActivity);
          }

          closeModal();

        } else {
          showFailedMsg();
          console.log("show failed msg 1")
        }

      } else {
        showFailedMsg();
        console.log("show failed msg 2")
      }

    } catch (error) {
      showFailedMsg();
      console.log("show failed msg 3", error)
    }

  };

  const saveActivity = (e, mode) => {
    //mode: 0=Save, 1=Save & Mark Done, 2 = Save, Mark Done & Add Followup
    saveMode = mode;
    submitRef.current.click();
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();
    console.log(profile);
    if (
      form.checkValidity() &&
      (profile.company && profile.company.value !== 0) &&
      (profile.individual && profile.individual.value !== 0) &&
      (profile.activityType && profile.activityType.value !== 0) &&
      (profile.activityFor && profile.activityFor.value > 0) &&
      (profile.followupRecurrence) &&
      (profile.activityDate) &&
        (profile.followupRecurrence && profile.followupRecurrence.value === 0 ? true :
          (profile.followupRepeatForever ? true :
            (profile.followupEndDate)
          )
        )
      //(profile.activityStatus)
    ) {
      console.log("SUBMIT ACTIVITY")
      console.log(profile.activityType.value)
      console.log(saveMode)
      if (saveMode > 0 && profile.activityType.value===5 && profile.activityNotes===initialActivityNotes) {
        setCheckNotes(true);
        setCheckType(true);
        setValidated(false);
        console.log("check notes and type true")  
      }
      else if(saveMode>0 && profile.activityType.value===5) {
        setValidated(false);
        setCheckType(true);
        console.log("check type true")
      }
      else if (saveMode > 0 && profile.activityNotes===initialActivityNotes){
        setValidated(false);
        setCheckNotes(true);
        console.log("check notes true")
      }
      else if ((saveMode===0 && profile.activityNotes===initialActivityNotes)||profile.activityNotes!==initialActivityNotes){
        setValidated(true);
        await submitActivity();
        console.log("submit activity")
      }
    } else {
      console.log("Profile",profile)
      console.log("Set valid false")
      setValidated(false);
    }
  };

  //handle one-time startup initializations
  useEffect(() => {

    const fetchAccount = async () => {
      try {
        const identity = jwtDecode(storedToken);
        setIdentity(identity);
      } catch (error) {
        console.error('Error:', error);
      }
    };

    const fetchActivityTypes = async () => {
      try {
        const response = await fetch(activityTypesEndpoint, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            'Content-Type': 'application/json',
          }
        });
        if (response.ok) {
          const data = await response.json();
          // const filteredActivities = data.filter(activity => activity.value !== 5 || activity.label !== 'Follow-Up');
          // console.log(filteredActivities);
          setActivitiyTypes(data);
        } else {
          console.error('Failed to fetch ActivitiyTypes');
        }
      } catch (error) {
        console.error('Failed to fetch ActivitiyTypes');
      }
    };

    if (storedToken) {
      fetchAccount();
      fetchActivityTypes();
    } else {
      console.log('Token not found in localStorage');
    }

  }, []);

  //handle open and close modal initializations
  useEffect(() => {

    if (showModal && storedToken) {
      //modal opening

      let editMode = false;
      let followupMode = false;
      console.log("activityInfo",activityInfo)
      // console.log("Object.keys(activityInfo)",Object.keys(activityInfo).length > 0)
      if (activityInfo && Object.keys(activityInfo).length > 0) {
        editMode = activityInfo.ID > 0;
        followupMode = activityInfo.ID === -2;
      }
      if (editMode) {
        //edit mode
        setEditMode(true);
        setFollowupMode(false);
        setProfile((prevProfile) => ({
          ...prevProfile,
          id: activityInfo.ID,
          parent: allParents.find(x => x.value === activityInfo.ParentID),
          company: allCompanies.find(x => x.value === activityInfo.CompanyID),
          individual: { value: activityInfo.IndividualID, label: activityInfo.IndividualName },
          activityFor: { value: activityInfo.ActivityForID, label: activityInfo.ActivityForName },
          activityType: activitiyTypes.find(x => x.value === activityInfo.TypeID),
          activityDate: activityInfo.StartDate === "0001-01-01T00:00:00" ? null : new Date(activityInfo.StartDate),
          activityNotes: activityInfo.ActivityComments,
          followupRecurrence: activityRecurrences.find(x => x.value === activityInfo.FollowUpRecurrenceType),
          followupEndDate: activityInfo.FollowUpEndDate === "0001-01-01T00:00:00" ? null : new Date(activityInfo.FollowUpEndDate),
          followupRepeatForever: activityInfo.FollowUpRecurrenceType === 0 ? true : (activityInfo.FollowUpEndDate === "0001-01-01T00:00:00" ? true : false),
        }));
        activitiyTypes.find(x => x.value === activityInfo.TypeID) === activitiyTypes.find(x => x.value === 5) ? setFollowUpSelected(true): setFollowUpSelected(false);
        setInitialActivityNotes(activityInfo.ActivityComments);
      } else if (followupMode) {
        //followup mode (create mode with full data)
        console.log("setting follow-up mode")
        setEditMode(false);
        setFollowupMode(true);
        setFollowUpSelected(true);
        setProfile((prevProfile) => ({
          ...prevProfile,
          id: 0,
          parent: allParents.find(x => x.value === activityInfo.ParentID),
          company: allCompanies.find(x => x.value === activityInfo.CompanyID),
          individual: { value: activityInfo.IndividualID, label: activityInfo.IndividualName },
          activityFor: { value: activityInfo.ActivityForID, label: activityInfo.ActivityForName },
          activityType: activitiyTypes.find(x => x.value === 5), //type is followup for followups
          activityDate: null, //no activity date for followups (user must enter date)
          activityNotes: activityInfo.ActivityComments,
          followupRecurrence: activityRecurrences.find(x => x.value === 0), //recurrence is once for followups
          followupEndDate: null, //no end date followups
          followupRepeatForever: false,  //no repeat for followups
        }));
        setFollowUpSelected(true);
      } else {
        //create mode
        setEditMode(false);
        setFollowupMode(false);

        //let o = (allEmployees.find(x => x.data === identity.sub.toUpperCase()));
        //if (o) {
        //  console.log(o);
        //}

        setProfile((prevProfile) => ({
          ...prevProfile,
          id: 0,
          parent: allParents.find(x => x.value === (selectedCompanyParentID ? selectedCompanyParentID : selectedParentID)),
          company: allCompanies.find(x => x.value === (selectedCompanyID ? selectedCompanyID : null)),
          individual: activityInfo && activityInfo.IndividualID && activityInfo.IndividualName ? { value: activityInfo.IndividualID, label: activityInfo.IndividualName } : null,
          activityFor: (allEmployees.find(x => x.data === identity.sub.toUpperCase())),
          activityType: activitiyTypes.find(x => x.value === 5),
          activityStart: new Date(),
          activityNotes: "",
          followupRecurrence: activityRecurrences[0],
          followupEndDate: null,
          followupRepeatForever: true,
        }));
        setFollowUpSelected(true);
      }
    } else {
      //modal closing
      clearProfile();
      setValidated(false);
      setCheckNotes(false);
      setCheckType(false);
      setFollowUpSelected(false);
    }
  }, [showModal]);



  const loadParentOptions = async (searchterm) => {

    let results = [];

    const response = await fetch(parentsSearch + `?searchterm=${searchterm}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${storedToken}`,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const data = await response.json();
      results = data.results;
    }

    return results;
  };

  const loadCompanyOptions = async (searchterm) => {

    let results = [];
    let parentid = profile && profile.parent ? profile.parent.value : 0;

    const response = await fetch(companySearch + `?searchterm=${searchterm}&parentid=${parentid}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${storedToken}`,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const data = await response.json();
      results = data.results;
    }

    return results;
  };

  const loadIndividualOptions = async (searchterm) => {

    let results = [];
    let parentid = profile && profile.parent ? profile.parent.value : 0;
    let companyid = profile && profile.company ? profile.company.value : 0;

    const response = await fetch(individualsSearch + `?searchterm=${searchterm}&parentid=${parentid}&companyid=${companyid}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${storedToken}`,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const data = await response.json();
      results = data.results;
    }

    return results;
  };

  return (
    <Modal show={showModal} onHide={closeModal} className='activityModal' backdrop="static">
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{editMode ? 'Edit Activity ' : followupMode ? 'Add Follow-Up Activity ' : 'Add New Activity '}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Row className='mb-3'>
            <Form.Group as={Col} md="12" controlId="parent">
              <FloatingLabel controlId="parent" label="Company Parent" className="w-100 floating-select">
                <AsyncSelect
                  name="parent"
                  className="companyform-dropdown"
                  classNamePrefix="select"
                  isClearable={true}
                  cacheOptions
                  loadOptions={loadParentOptions}
                  defaultOptions={true}
                  value={profile.parent}
                  onChange={handleParentChange}
                  menuPosition={'fixed'} //this to allows option menu to open on top when there is not room to open on bottom
                  menuPortalTarget={document.body} //this to fix z-index issue on using react select in a modal
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                />
              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-3'>
            <Form.Group as={Col} md="12" controlId="company">
              <FloatingLabel controlId="company" label="Company Name" className="w-100 floating-select required">
                <AsyncSelect
                  name="company"
                  className={validated ? (profile.company && profile.company.value !== 0 ? "companyform-dropdown valid" : "companyform-dropdown invalid") : "companyform-dropdown"}
                  classNamePrefix="select"
                  isClearable={true}
                  key={profile && profile.parent ? profile.parent.value : 0} //this is the magic bit that forces the reload
                  cacheOptions
                  loadOptions={loadCompanyOptions}
                  defaultOptions={true}
                  value={profile.company}
                  onChange={handleCompanyChange}
                  menuPosition={'fixed'} //this to allows option menu to open on top when there is not room to open on bottom
                  menuPortalTarget={document.body} //this to fix z-index issue on using react select in a modal
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                />
                {(validated && !(profile.company && profile.company.value !== 0)) ?
                  <div className="custom-error-label">Company is required.</div>
                  : null}
              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-3'>
            <Form.Group as={Col} md="12" controlId="individual">
              <FloatingLabel controlId="individual" label="Contact" className="w-100 floating-select required">
                <AsyncSelect
                  name="individual"
                  className={validated ? (profile.individual && profile.individual.value !== 0 ? "companyform-dropdown valid" : "companyform-dropdown invalid") : "companyform-dropdown"}
                  classNamePrefix="select"
                  isClearable={true}
                  key={profile ? (profile.parent ? profile.parent.value : (profile.company ? profile.company.value : 0)) : 0} //this is the magic bit that forces the reload
                  cacheOptions
                  loadOptions={loadIndividualOptions}
                  defaultOptions
                  value={profile.individual}
                  onChange={handleIndividualChange}
                  menuPortalTarget={document.body} //this to fix z-index issue on using react select in a modal
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                />
                {(validated && !(profile.individual && profile.individual.value !== 0)) ?
                  <div className="custom-error-label">Individual is required.</div>
                  : null}
              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-3'>
            <Form.Group as={Col} md="12" controlId="activitytype">
              <FloatingLabel controlId="activitytype" label="Activity Type" className="w-100 floating-select required">
                <Select
                  name="activitytype"
                  className={validated ? (profile.activityType && profile.activityType.value !== 0 ? "companyform-dropdown valid" : "companyform-dropdown invalid") : "companyform-dropdown"}
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  options={activitiyTypes}
                  value={profile.activityType}
                  onChange={handleActivityTypeChange}
                  filterOption={createFilter({ ignoreAccents: false })} //this for performance
                  components={{ Option: CustomOption }} //this for performance
                />
                {(checkType) ?
                  <div className="custom-error-label">Please update the Activity Type to indicate how you followed up before marking done.</div>
                  : null}
                {(validated && !(profile.activityType && profile.activityType.value !== 0)) ?
                  <div className="custom-error-label">Activity Type is required.</div>
                  : null}
              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-3'>
            <Form.Group as={Col} md="12" controlId="activityDate">
              <FloatingLabel controlId="activityDate" label={followupSelected?"Follow-Up Date":"Activity Date"} className="w-100 floating-datepicker">

                <DatePicker
                  className="activity-form-datepicker"
                  dateFormat="E. MM/dd/yyyy"
                  selected={profile.activityDate}
                  onChange={(date) => handleStartDateChange(date)}
                  showIcon
                  icon="fa fa-calendar"
                  toggleCalendarOnIconClick
                />
                {(validated && !(profile.activityDate)) ?
                  <div className="custom-error-label">Activity Date is required.</div>
                  : null}

              </FloatingLabel>
            </Form.Group>
          </Row>


          {/*{editMode ?*/}
          {/*  <Row className='mb-3'>*/}
          {/*    <Form.Group as={Col} md="12" controlId="activitystatus">*/}
          {/*      <FloatingLabel controlId="activitystatus" label="Activity Status" className="w-100 floating-select">*/}

          {/*        <Select*/}
          {/*          name="activitystatus"*/}
          {/*          className={validated ? (profile.activityStatus ? "companyform-dropdown valid" : "companyform-dropdown invalid") : "companyform-dropdown"}*/}
          {/*          classNamePrefix="select"*/}
          {/*          isClearable={true}*/}
          {/*          isSearchable={true}*/}
          {/*          options={activityStatuses}*/}
          {/*          value={profile.activityStatus}*/}
          {/*          onChange={handleActivityStatusChange}*/}
          {/*          filterOption={createFilter({ ignoreAccents: false })} //this for performance*/}
          {/*          components={{ Option: CustomOption }} //this for performance*/}
          {/*        />*/}
          {/*        {(validated && !(profile.activityStatus)) ?*/}
          {/*          <div className="custom-error-label">Activity Status is required.</div>*/}
          {/*          : null}*/}

          {/*      </FloatingLabel>*/}
          {/*    </Form.Group>*/}
          {/*  </Row> : null}*/}


          <Row className='mb-3'>
            <Form.Group as={Col} md="12" controlId="activityNotes">
              <FloatingLabel controlId="activityNotes" label="Activity Notes" className="w-100">
                <Form.Control
                  name='activityNotes'
                  className="activity-textarea"
                  as="textarea"
                  rows={3}
                  placeholder="Activity Notes"
                  value={profile.activityNotes}
                  onChange={handleProfileChange}
                />
                {(validated && !(profile.activityNotes)) ?
                  <div className="custom-error-label">Activity Notes are required.</div>
                  : null}
                {(checkNotes) ?
                  <div className="custom-error-label">Please add final notes before Marking Done.</div>
                  : null}
                  {/*|| initialActivityNotes === profile.activityNotes */}
              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-3'>
            <Form.Group as={Col} md="12" controlId="activityFor">
              <FloatingLabel label="Assigned To" className="w-100 floating-select required">
                <Select
                  className={validated ? (profile.activityFor ? "companyform-dropdown valid" : "companyform-dropdown invalid") : "companyform-dropdown"}
                  classNamePrefix="select"
                  options={allEmployees}
                  value={profile.activityFor}
                  isClearable={true}
                  onChange={handleActivityForChange}
                />
                {(validated && !(profile.activityFor)) ?
                  <div className="custom-error-label">Assigned To is required.</div>
                  : null}
              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-3'>
            <Form.Group as={Col} md="12" controlId="followuprecurrence">
              <FloatingLabel controlId="followuprecurrence" label="Recurrence" className="w-100  floating-select required">

                <Select
                  name="followuprecurrence"
                  className={validated ? (profile.followupRecurrence ? "companyform-dropdown valid" : "companyform-dropdown invalid") : "companyform-dropdown"}
                  classNamePrefix="select"
                  isSearchable={true}
                  options={activityRecurrences}
                  value={profile.followupRecurrence}
                  onChange={handleFollowupRecurrenceChange}
                  filterOption={createFilter({ ignoreAccents: false })} //this for performance
                  components={{ Option: CustomOption }} //this for performance
                />
                {(validated && !(profile.followupRecurrence)) ?
                  <div className="custom-error-label">Followup Recurrence is required.</div>
                  : null}

              </FloatingLabel>
            </Form.Group>
          </Row>

          {!profile.followupRecurrence || profile.followupRecurrence.value !== 0 ?
            <Row className='mb-3'>
              <Form.Group as={Col} md="6" controlId="followupRepeatForever">
                <div className="modal-header-checkbox-container mt-3">
                  <label className="modal-header-checkbox-label" htmlFor="followupRepeatForever">Repeat Forever?</label>
                  <input className="modal-header-checkbox" type="checkbox" name="followupRepeatForever" id="followupRepeatForever" checked={profile.followupRepeatForever} onChange={handleRepeatForeverChange} />
                </div>
              </Form.Group>
              {!profile.followupRepeatForever ?
                <Form.Group as={Col} md="6" controlId="followupEndDate">
                  <FloatingLabel controlId="followupEndDate" label="Recurrence End Date" className="w-100 floating-datepicker">
                    <DatePicker
                      className="activity-form-datepicker"
                      dateFormat="E. MM/dd/yyyy"
                      selected={profile.followupEndDate}
                      onChange={(date) => handleFollowupEndDateChange(date)}
                      showIcon
                      icon="fa fa-calendar"
                      toggleCalendarOnIconClick
                    />
                    {(validated && !(profile.followupEndDate)) ?
                      <div className="custom-error-label">Recurrence End Date is required.</div>
                      : null}
                  </FloatingLabel>
                </Form.Group>
                : null}
            </Row>
            : null}

          {/*{!profile.followupRepeatForever && (!profile.followupRecurrence || profile.followupRecurrence.value !== 0) ?*/}
          {/*<Row className='mb-3'>*/}
          {/*  <Form.Group as={Col} md="12" controlId="followupEndDate">*/}
          {/*    <FloatingLabel controlId="followupEndDate" label="Followup End Date" className="w-100 floating-datepicker">*/}

          {/*      <DatePicker*/}
          {/*        className="activity-form-datepicker"*/}
          {/*        dateFormat="E. MM/dd/yyyy"*/}
          {/*        selected={profile.followupEndDate}*/}
          {/*        onChange={(date) => handleFollowupEndDateChange(date)}*/}
          {/*        showIcon*/}
          {/*        icon="fa fa-calendar"*/}
          {/*        toggleCalendarOnIconClick*/}
          {/*      />*/}

          {/*    </FloatingLabel>*/}
          {/*  </Form.Group>*/}
          {/*  </Row> : null}*/}

        </Modal.Body>

        <Modal.Footer>

          <Button variant="secondary" onClick={closeModal}>
            Quit
          </Button>

          {!followupMode ?
            <Dropdown as={ButtonGroup} onClick={e => { if (e) { e.preventDefault(); e.stopPropagation() } }}>
              <Dropdown.Toggle variant="success">
                <i className="bi bi-check-lg" aria-hidden="true"></i>
                <span className="btn-activity-card-done">Save</span>
                <i className="fa fa-caret-down caret-center" aria-hidden="true"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={(e) => saveActivity(e, 0)}>Save</Dropdown.Item>
                <Dropdown.Item onClick={(e) => saveActivity(e, 1)}>Save & Mark Done</Dropdown.Item>
                <Dropdown.Item onClick={(e) => saveActivity(e, 2)}>Save, Mark Done & Add Followup</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            : null}

          {/*<Button style={{ display: "none" }} ref={submitRef} variant="primary" type="submit">Save</Button>*/}
          <Button
            style={{ display: followupMode ? "" : "none" }}
            ref={submitRef}
            variant="success"
            type="submit">
            <span className="me-2">
              <i className="bi bi-check-lg"></i>
            </span>
            Save
          </Button>



        </Modal.Footer>

      </Form>

    </Modal>


  );
}